// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./Shop.module.css";
// CSS
// Models
import { I_ShopItem } from "../../Models/interfaces";
// Models
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Services
import { getProductsByUserToken } from "../../Services/Common/getProductsByUserToken";
// Services
// Components
import ShopCard from "./ShopCard/ShopCard";
import ShopModal from "./ShopModal/ShopModal";
// Components
// Images
import { shop_header } from "../../Images/images";
// Images
// Modules
import Swal from "sweetalert2";
// Modules
// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// Skeleton

type ShopProps = { className?: string };

const Shop: React.FunctionComponent<ShopProps> = ({ className }) => {
  //   States
  const [products, setProducts] = useState<I_ShopItem[]>([]);
  //
  const [modalData, setModalData] = useState<I_ShopItem>({
    download_able: false,
    gift_price: 0,
    has_paid: false,
    id: 1,
    image_url: "",
    price: 0,
    title: "",
    lesson_id: "",
  });
  //
  const [isModalInScreen, setIsModalInScreen] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(true);
  //   States
  /************************************************************* */
  /************************************************************* */
  /************************************************************* */
  /************************************************************* */
  //   Contexts
  const userToken = useContext(UserTokenContext);
  //   Contexts
  /************************************************************* */
  /************************************************************* */
  /************************************************************* */
  /************************************************************* */
  // Life Cycles
  useEffect(() => {
    getProductsByUserToken(userToken)
      .then(({ data: { data }, status }) => {
        setIsPending(false);
        if (status === 200 || 201) {
          setProducts(data);
          return;
        } else {
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        Swal.fire({
          icon: "error",
          title: err?.response?.data?.message
            ? err?.response?.data?.message
            : err.message,
        });
      });
  }, [userToken]);
  // Life Cycles
  /************************************************************* */
  /************************************************************* */
  /************************************************************* */
  /************************************************************* */

  return (
    <div
      className={`${styles.shopContainer} ${className} w-full flex flex-col items-center justify-start`}
    >
      <img
        src={shop_header}
        alt=""
        className={`${styles.shopHeaderImg} w-full object-contain`}
      />
      <p className="mt-4">جـــزوات آنـــلاین</p>
      <p className="mt-2">دسترسی به بهترین ومعتبرترین منابع درسی</p>
      <div
        className={`${styles.shopItemsContainer} w-full flex flex-col items-center justify-start overflow-y-scroll`}
      >
        {isPending ? (
          <>
            <SkeletonTheme
              baseColor="rgba(126, 58, 229 , 0.1)"
              highlightColor="rgba(126, 0, 229, 0.6)"
            >
              <p>
                <Skeleton
                  count={6}
                  width={
                    window.innerWidth > 600 ? "550px" : "calc(100vw - 2rem)"
                  }
                  height={"8vh"}
                  style={{ marginTop: "1rem" }}
                />
              </p>
            </SkeletonTheme>
          </>
        ) : (
          <>
            {products.map((item) => (
              <ShopCard
                key={item.id}
                data={item}
                onClick={() => {
                  setModalData(item);
                  setIsModalInScreen(true);
                }}
              />
            ))}
          </>
        )}
      </div>
      {isModalInScreen ? (
        <>
          <ShopModal
            productData={modalData}
            setIsModalInScreen={setIsModalInScreen}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Shop;
